import {
    Component,
    ChangeDetectionStrategy,
    ElementRef,
    ViewChild,
    Output,
    EventEmitter,
    Input,
    ChangeDetectorRef,
    HostBinding,
} from '@angular/core';
import { MatLegacyOptionSelectionChange as MatOptionSelectionChange } from '@angular/material/legacy-core';
import { SearchService } from './search.service';
import { GoogleAnalyticsService } from '../../../google-analytics.service';
import { BehaviorSubject } from 'rxjs';
import { StationNavigationService } from 'shared/stations-service/station-navigation.service';
import { EnvironmentService } from 'providers/environment.service';

@Component({
    selector: 'ce-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent {
    @Input() @HostBinding('class') public themeClass: 'theme-mykempower' | 'theme-chargeye' = 'theme-chargeye';

    @ViewChild('inputField') inputField: ElementRef;
    @Output() searchFocused = new EventEmitter<boolean>();
    text: string;

    currentBadge: HTMLDivElement;
    isSearchActive$ = new BehaviorSubject(false);

    constructor(
        public search: SearchService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private navigation: StationNavigationService,
        private cdRef: ChangeDetectorRef,
        private environmentService: EnvironmentService
    ) {
        this.environmentService.getAppOrigin$().subscribe((origin) => {
            this.themeClass = `theme-${origin}`;
            this.cdRef.markForCheck();
        });
    }

    onSelectionChange(event: MatOptionSelectionChange) {
        const id = event?.source?.id;

        if (id) {
            const badge = document.getElementById(id)?.getElementsByClassName('badge')?.item(0) as HTMLDivElement;
            this.currentBadge = badge;
            this.googleAnalyticsService.sendGlobalSearchToGA();
        }
    }

    ngAfterViewInit(): void {
        // Subscribe to input focus event
        this.inputField.nativeElement.addEventListener('focus', () => {
            this.isSearchActive$.next(true);
        });
        this.inputField.nativeElement.addEventListener('blur', () => {
            this.isSearchActive$.next(false);
            this.inputField.nativeElement.value = '';
            this.currentBadge = undefined;
            this.search.clear();
        });
        this.isSearchActive$.subscribe((isActive) => {
            this.searchFocused.emit(isActive);
        });

        // Set focus on the input field after the view has been initialized
        // this.inputField.nativeElement.focus();
    }

    openCurrentSelection() {
        this.currentBadge?.click();
        this.currentBadge = undefined;
    }

    onPaste($event: ClipboardEvent) {
        const pastedText = $event.clipboardData.getData('text');
        this.navigation.tryNavigateToStation(pastedText, (navigated: boolean) => {
            if (navigated) {
                // Clear the search field if a station was found
                this.search.clear();
            }
        });
    }
}
